export default __webpack_public_path__ + "static/media/3.769e293b.jpeg";